<script setup>
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
</script>
<template>
  <navbar-layout />
  <sidebar-layout v-if="userData != null" />
  <v-main id="content">
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="px-3 pb-2">
            <button @click="goBack" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
              Kontraktor : {{ kontraktor.namaKontraktor }}
            </button>
          </div>
          <div class="bg-white rounded-top-10 w-100" style="min-height: 60vh">
            <div class="container p-5">
              <div class="row mb-5">
                <div class="col-md-12">
                  <div class="d-flex">
                    <div class="pr-2" style="margin-right: 1rem">
                      <font-awesome-icon
                        v-if="url_icon == ''"
                        icon="fa-solid fa-building"
                        style="height: 3rem; color: #df4444"
                      />
                      <img :src="url_icon" style="height: 3rem" />
                    </div>
                    <div class="row w-100">
                      <div class="col-md-6">
                        <p
                          class="mb-1"
                          style="
                            font-size: 2rem;
                            line-height: 1.5rem;
                            font-family: 'Inter-Bold';
                          "
                        >
                          {{ kontraktor.namaKontraktor }}
                        </p>
                        <div style="font-size: 1rem">
                          Nilai Prakualifikasi : {{ kontraktor.nilaiPraKplh }} |
                          Predikat PJP :
                          <span
                            v-if="kontraktor.predikat == 'HIJAU'"
                            class="text-success"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-square"
                              style=""
                            />
                            {{
                              kontraktor.nilaiPredikat != null
                                ? kontraktor.nilaiPredikat
                                : "-"
                            }}
                          </span>
                          <span
                            v-else-if="kontraktor.predikat == 'EMAS'"
                            style="color: #e19140"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-square"
                              style=""
                            />
                            {{
                              kontraktor.nilaiPredikat != null
                                ? kontraktor.nilaiPredikat
                                : "-"
                            }}
                          </span>
                          <span
                            v-else-if="kontraktor.predikat == 'BIRU'"
                            style="color: #326bd5"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-square"
                              style=""
                            />
                            {{
                              kontraktor.nilaiPredikat != null
                                ? kontraktor.nilaiPredikat
                                : "-"
                            }}
                          </span>
                          <span
                            v-else-if="kontraktor.predikat == 'HITAM'"
                            style="color: #171716"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-square"
                              style=""
                            />
                            {{
                              kontraktor.nilaiPredikat != null
                                ? kontraktor.nilaiPredikat
                                : "-"
                            }}
                          </span>
                          <span
                            v-else-if="kontraktor.predikat == 'MERAH'"
                            class="text-danger"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-square"
                              style=""
                            />
                            {{
                              kontraktor.nilaiPredikat != null
                                ? kontraktor.nilaiPredikat
                                : "-"
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-5">
                <div class="col-md-9">
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    INFORMASI UMUM
                  </p>
                  <div class="d-flex mb-1">
                    <p
                      class="me-5"
                      style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                    >
                      Inisial : {{ kontraktor.inisial }}
                    </p>
                    <p
                      class="me-5"
                      style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                    >
                      Klasifikasi : {{ kontraktor.jenis }}
                      <!--                          <button type="button" class="btn btn-sm btn_cari" data-bs-toggle="modal" data-bs-target="#editKlasifikasi">
                                                      <font-awesome-icon icon="fa-solid fa-edit" style=""/>
                                                    </button>-->
                    </p>
                    <p
                      class="me-5"
                      style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-location-dot"
                        style=""
                      />
                      {{
                        kontraktor.wilayah == null ? "-" : kontraktor.wilayah
                      }}
                    </p>
                    <p
                      class="me-5"
                      style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                    >
                      Kualifikasi Usaha :
                      {{
                        kontraktor.kualifikasiUsaha == 1
                          ? "Kecil"
                          : kontraktor.kualifikasiUsaha == 2
                          ? "Sedang"
                          : kontraktor.kualifikasiUsaha == 3
                          ? "Besar"
                          : "-"
                      }}
                    </p>
                  </div>
                  <!-- <hr class="hr" /> -->
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    IZIN LEGALITAS
                  </p>
                  <div class="d-flex mb-2">
                    <table class="table table-borderless">
                      <tbody
                        style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                      >
                        <tr>
                          <td width="15%">No. NIB</td>
                          <td width="1%">:</td>
                          <td width="25%">
                            {{ kontraktor.nib == null ? "-" : kontraktor.nib }}
                          </td>
                        </tr>
                        <tr>
                          <td>No. IUJP</td>
                          <td>:</td>
                          <td>
                            {{
                              kontraktor.iujp == null ? "-" : kontraktor.iujp
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Masa Berlaku</td>
                          <td>:</td>
                          <td>
                            {{
                              kontraktor.masaBerlaku == null
                                ? "-"
                                : moment(kontraktor.masaBerlaku).format(
                                    "DD MMMM YYYY"
                                  )
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-md-3">
                  <div
                    class="rounded w-100 p-3"
                    style="min-height: 10vh; background-color: #fff1f1"
                  >
                    <p
                      class="mb-1"
                      style="
                        font-family: 'Inter-Thin';
                        font-size: 0.9rem;
                        letter-spacing: 0.1rem;
                        font-weight: bold;
                      "
                    >
                      INFORMASI PJO
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Bold'; font-size: 1.1rem"
                    >
                      {{ kontraktor.namaPjo }}
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                    >
                      No. Surat Pengesahan : {{ kontraktor.noPengesahanPjo }}
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                    >
                      Tgl Surat Pengesahan :
                      {{
                        kontraktor.tglSuratPengesahan != "" &&
                        kontraktor.tglSuratPengesahan != null
                          ? moment(kontraktor.tglSuratPengesahan).format(
                              "DD MMM YYYY"
                            )
                          : "-"
                      }}
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-user-check"
                        style="color: #df4444"
                      />
                      {{ kontraktor.kompetensiPjo }}
                    </p>
                    <p
                      class="mb-1 mt-2"
                      style="
                        font-family: 'Inter-Thin';
                        font-size: 0.9rem;
                        letter-spacing: 0.1rem;
                        font-weight: bold;
                      "
                    >
                      INFORMASI PIC
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Medium'; font-size: 0.8rem"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-envelope"
                        style="color: #df4444"
                      />
                      {{ kontraktor.picEmail }}
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Medium'; font-size: 0.8rem"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-phone"
                        style="color: #df4444"
                      />
                      {{ kontraktor.picPhone }}
                    </p>
                  </div>
                </div>
                <div class="col-md-12">
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    Kode KBLI
                  </p>
                  <div class="table-responsive">
                    <table class="table table-striped rounded">
                      <thead
                        style="
                          font-family: 'Inter-Regular';
                          font-style: normal;
                          font-weight: 500;
                          font-size: 14px;
                          line-height: 24px;
                          color: #28293d;
                        "
                      >
                        <tr class="table-danger" style="max-height: 5vh">
                          <th width="6%">Kode</th>
                          <th width="20%">Judul</th>
                          <th class="text-center" width="14%">
                            Tingkat Resiko
                          </th>
                          <th class="text-center" width="10%">
                            Sertifikat Standar
                          </th>
                          <th class="text-center" width="10%">Izin</th>
                          <!--                            <th class="text-center" width="8%">Is Verified</th>-->
                        </tr>
                      </thead>
                      <tbody
                        style="
                          font-family: 'Inter-Regular';
                          font-style: normal;
                          font-weight: 500;
                          font-size: 14px;
                          line-height: 24px;
                          color: #28293d;
                        "
                      >
                        <tr v-for="kb in kbli" :key="kb.noKbli">
                          <td>
                            {{
                              kb.noKbli.length == 4
                                ? "0" + kb.noKbli
                                : kb.noKbli
                            }}
                          </td>
                          <td>{{ kb.deskripsi }}</td>
                          <td class="text-center">{{ kb.tingkatResikoStr }}</td>
                          <td class="text-center">
                            <div
                              v-if="
                                kb.fileSertifikat != null &&
                                kb.tingkatResiko != 4
                              "
                            >
                              <img
                                :src="
                                  kb.isVerified
                                    ? require('@/assets/icons/verified.png')
                                    : require('@/assets/icons/close-64.png')
                                "
                                alt="icon"
                                :style="{
                                  width: kb.isVerified ? '6rem' : '4rem',
                                  marginLeft: kb.isVerified ? '-0.8rem' : '0',
                                }"
                              />
                            </div>
                            <a v-else>-</a>
                          </td>
                          <td class="text-center">
                            <div
                              v-if="
                                kb.fileIzin != null && kb.tingkatResiko == 4
                              "
                            >
                              <img
                                :src="
                                  kb.isVerified
                                    ? require('@/assets/icons/verified.png')
                                    : require('@/assets/icons/close-64.png')
                                "
                                alt="icon"
                                :style="{
                                  width: kb.isVerified ? '6rem' : '4rem',
                                  marginLeft: kb.isVerified ? '-0.8rem' : '0',
                                }"
                              />
                            </div>
                            <a v-else>-</a>
                          </td>
                          <!--                            <td class="text-start">
                              <img
                                  :src="kb.isVerified ? require('@/assets/icons/verified.png') : require('@/assets/icons/close-64.png')"
                                  alt="icon"
                                  :style="{
                            width: kb.isVerified ? '6rem' : '4rem',
                            marginLeft: kb.isVerified ? '-0.8rem' : '0'
                          }"
                              />
                            </td>-->
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row mb-1">
                <div class="col-md-10">
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    SUB KONTRAKTOR
                  </p>
                </div>
              </div>
              <div class="row mb-5" v-if="subkontraktor != null">
                <div class="col-md-12">
                  <div
                    class="border border-1 border-light"
                    :class="{ 'bg-gray': index % 2 === 1 }"
                  >
                    <div class="table-responsive">
                      <table class="table table-striped rounded">
                        <tbody
                          style="
                            font-family: 'Inter-Regular';
                            font-style: normal;
                            font-weight: 500;
                            font-size: 14px;
                            line-height: 24px;
                            color: #28293d;
                          "
                        >
                          <tr
                            v-for="(sbk, index) in subkontraktor"
                            :key="index"
                          >
                            <td width="5%">{{ index + 1 }}</td>
                            <td width="85%">
                              <a
                                class="pointer link-danger text-decoration-none"
                                style=""
                                >{{ sbk.namaKontraktor }}</a
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-5" v-else>
                <p
                  class="mb-1 text-center"
                  style="
                    font-family: 'Inter-Thin';
                    font-size: 0.9rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                  "
                >
                  Tidak Ada Subkontraktor
                </p>
              </div>
              <div class="row" v-if="kontraktor.bidang != null">
                <div class="col-md-4">
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    BIDANG
                  </p>
                  <ul class="list-group w-100">
                    <li
                      v-for="(bid, index) in bd"
                      :key="index"
                      :class="{
                        'list-group-item': true,
                        'list-bidang': true,
                        'bg-gray': index % 2 === 1,
                      }"
                    >
                      {{ bid }}
                    </li>
                  </ul>
                </div>
                <div class="col-md-8">
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    SUB BIDANG
                  </p>
                  <table>
                    <tbody>
                    <tr
                      v-for="(sbid, index) in sbd"
                      :key="index"
                      :class="{ 'bg-gray': index % 2 === 1 }"
                    >
                      <td width="50%">{{ sbid.sb }}</td>
                      <!--                          <td width="15%">
                            <img
                                :src="sbid.is_verified ? require('@/assets/icons/verified.png') : require('@/assets/icons/close-64.png')"
                                alt="icon"
                                :style="{
                          width: sbid.is_verified ? '6rem' : '4rem',
                          marginLeft: sbid.is_verified ? '.8rem' : '0'
                        }"
                            />
                          </td>-->
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row" v-else>
                <p
                  class="mb-1 text-center"
                  style="
                    font-family: 'Inter-Thin';
                    font-size: 0.9rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                  "
                >
                  Tidak Ada Data Bidang dan Sub Bidang
                </p>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-main>
  <FooterLayout/>
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>

<style scoped>
table tr td,
table tr th {
  padding: 0.75rem 1rem;
}

section {
  font-family: "Inter", sans-serif;
  font-style: normal;
  min-height: 100vh;
}

.list-bidang {
  border-radius: 0px !important;
}

.bg-gray {
  background-color: #f2f2f5;
}

.bg-red-ss {
  background-color: #f8d7da;
}
.rounded-top-10 {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
</style>
<script>
// import router from "../router";
import GlobalDataMixin from "../GlobalDataMixin";
import axios from "axios";

import {
  API_BASE_URL,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_VIEW_IMAGE,
  CMS_DOWNLOAD,
  CMS_VIEW_DOCUMENT,
  CMS_SET_KONTRAKTOR_PJP,
} from "../constants.js";
import router from "@/router";
import NavbarLayout from "@/layouts/NavbarLayout.vue";
import SidebarLayout from "@/layouts/SidebarLayout.vue";
import FooterLayout from "@/layouts/FooterLayout.vue";

const url = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_download = API_BASE_URL + CMS_DOWNLOAD;
const url_simpan = API_BASE_URL + CMS_SET_KONTRAKTOR_PJP;
const url_view_document = API_BASE_URL + CMS_VIEW_DOCUMENT;
const max_file_size = 5;

export default {
  mixins: [GlobalDataMixin],
  components: { NavbarLayout, SidebarLayout, FooterLayout },
  name: "DetailKontraktorPage",
  data() {
    return {
      isLoading: true,
      kontraktor: {},
      bidang: [],
      kbli: [],
      bd: [],
      sbd: [],
      // subkontraktor:['PT Sapta Indrasejati (SIS)','PT Rezki Batulicin Transport','PT Golden Energi Cemerlang Lestari (GECL)', 'PT Merdeka Sejati','PT Golden Gemilang','PT Jaya Sentosa'],
      subkontraktor: [],
      url_icon: "",
      url_file_nib: "",
      url_file_iujp: "",
      selectedOption: null,
      options: [
        { value: 1, label: "Kecil" },
        { value: 2, label: "Sedang" },
        { value: 3, label: "Besar" },
      ],
      predikatPjp: null,
      pjpOptions: [
        { value: "HIJAU", label: "HIJAU" },
        { value: "EMAS", label: "EMAS" },
        { value: "BIRU", label: "BIRU" },
        { value: "HITAM", label: "HITAM" },
        { value: "MERAH", label: "MERAH" },
      ],
      nilaiPjp: null,
      id_kontraktor: null,
      dataChanges: {},
      validasiFile: {
        typeCoc: false,
        sizeCoc: false,
        typePengesahanPjo: false,
        sizePengesahanPjo: false,
      },
      fileNameCoc: {
        docSio: null,
        suratPengesahan: null,
      },
      kontraktorID: null,
      klasifikasi: "",
      klasifikasiOpt: ["Inti", "Non Inti"],
      sio: {},
    };
  },
  methods: {
    fetchData(id) {
      axios
        .get(url + id)
        .then((response) => {
          console.log(response);
          this.kontraktor = response.data.detailKontraktor;
          this.url_icon =
            this.kontraktor.image != null
              ? API_BASE_URL + CMS_VIEW_IMAGE + this.kontraktor.image
              : "";
          this.url_file_nib =
            this.kontraktor.fileNib != null
              ? url_download + this.kontraktor.fileNib
              : null;
          this.url_file_iujp =
            this.kontraktor.fileIujp != null
              ? url_download + this.kontraktor.fileIujp
              : null;
          this.selectedOption = this.kontraktor.kualifikasiUsaha;
          this.predikatPjp = this.kontraktor.predikat;
          this.id_kontraktor = this.$route.params.id;
          this.nilaiPjp = this.kontraktor.nilaiPredikat;
          this.klasifikasi = this.kontraktor.jenis;
          // loop bidang-subbidang
          var arr_bid = [];
          var abd = [];
          var asbd = [];
          var temp_key = "";
          var b = 0;
          var sb = 1;
          for (var key in this.kontraktor.bidang) {
            var subi = this.kontraktor.bidang[key];
            if (temp_key != key) {
              temp_key = key;
              b += 1;
              sb = 1;
            }
            abd.push(b + ". " + key);

            for (var xx in subi) {
              arr_bid.push({
                bidang: b + ". " + key,
                subBidang: b + "." + sb + ". " + subi[xx],
              });
              asbd.push({
                sb: b + "." + sb + ". " + subi[xx].split("-")[0],
                is_verified: JSON.parse(subi[xx].split("-")[1]),
                notes:
                  subi[xx].split("-")[2] === "null"
                    ? null
                    : subi[xx].split("-")[2],
              });
              sb++;
            }
          }
          this.bidang = arr_bid;
          // end loop bidang-subbidang

          this.kbli = response.data.dataKbli;
          this.bd = abd;
          this.sbd = asbd;
          this.subkontraktor = response.data.subkontraktor;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data List Kontraktor : " + error.message);
          console.error("Error fetching data:", error);
        });
    },
    editProfile() {
      this.$router.push({
        name: "/editprofile",
        params: { id: this.$route.params.id },
      });
    },
    addSubkontraktor() {
      this.$router.push("/addsubkontraktor");
    },
    viewSubkontraktor(id) {
      this.$router.push("/subkontraktor/" + id);
    },
    toVerifikasiData(id) {
      this.$router.push("/verifikasiDataKontraktor/" + id);
    },
    redirectToLink(link, id) {
      router.push(link + id);
    },
    downloadFile(filename) {
      window.open(url_download + filename, "_blank");
    },
    handleFileDownload(blobData, filename) {
      // Create a Blob from the response data
      const blob = new Blob([blobData], { type: "application/octet-stream" });
      console.log("blob nya = ", blob);
      // Create a link element and trigger a download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename; // Set the desired file name
      link.click();
    },
    OnFormSubmit() {
      console.log("data nya = ", this.selectedOption);
      this.simpanKualifikasiUsaha(this.selectedOption);
    },
    simpanKualifikasiUsaha(selectedOptions) {
      // console.log('tp',this.formValues.tanggalPengesahan);
      let bodyJsonProfile = {
        id: this.$route.params.id,
        kualifikasiUsaha: selectedOptions,
        kblis: [],
      };
      axios
        .post(url_simpan, bodyJsonProfile, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response simpanEditProfile: ", response);
          window.location.reload();
        })
        .catch((error) => {
          console.log("error simpanEditProfile : ", error);
        });
    },
    OnFormSubmitPjp() {
      this.simpanPredikatPjp(this.predikatPjp, this.nilaiPjp);
    },
    simpanPredikatPjp(predikatPjp, nilaiPjp) {
      // console.log('tp',this.formValues.tanggalPengesahan);
      let bodyJsonProfile = {
        id: this.$route.params.id,
        predikat: predikatPjp,
        nilaiPredikat: nilaiPjp,
        kblis: [],
      };
      axios
        .post(url_simpan, bodyJsonProfile, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response simpanEditProfile: ", response);
          window.location.reload();
        })
        .catch((error) => {
          console.log("error simpanEditProfile : ", error);
        });
    },
    viewFile(fileName) {
      window.open(url_view_document + fileName, "_blank");
    },
    closeModal() {
      document.getElementById("btnClose").click();
    },
    handleChangeFile(refFile) {
      let file = null;
      if (refFile == "docSio") {
        file = this.$refs.fileDokumenCoc.files[0];
      } else if (refFile == "suratPengesahan") {
        file = this.$refs.fileDokumenPjo.files[0];
      }

      if (file) {
        // Check file type
        if (file.type !== "application/pdf") {
          if (refFile == "docSio") {
            this.validasiFile.typeCoc = true;
            this.validasiFile.sizeCoc = false;
            this.$refs.fileDokumenCoc.value = "";
          } else if (refFile == "suratPengesahan") {
            this.validasiFile.typePengesahanPjo = true;
            this.validasiFile.sizePengesahanPjo = false;
            this.$refs.fileDokumenPjo.value = "";
          }
          return;
        }

        // Check file size ({{max_file_size}}MB limit)
        if (file.size > max_file_size * 1024 * 1024) {
          if (refFile == "docSio") {
            this.validasiFile.typeCoc = false;
            this.validasiFile.sizeCoc = true;
            this.$refs.fileDokumenCoc.value = "";
          } else if (refFile == "suratPengesahan") {
            this.validasiFile.typePengesahanPjo = false;
            this.validasiFile.sizePengesahanPjo = true;
            this.$refs.fileDokumenPjo.value = "";
          }
          return;
        }

        // Reset error messages if the file is valid
        if (refFile == "docSio") {
          this.validasiFile.typeCoc = false;
          this.validasiFile.sizeCoc = false;
        } else if (refFile == "suratPengesahan") {
          this.validasiFile.typePengesahanPjo = false;
          this.validasiFile.sizePengesahanPjo = false;
        }

        // Handle the valid file as needed (e.g., store the file)
        // console.log('Valid file:', file);
      }
    },
    goBack() {
      if (window.history.state?.back) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: "/infokontraktor",
          query: this.$route.query,
        });
      }
    },
  },
  mounted() {
    this.kontraktorID = this.$route.params.id;
    this.fetchData(this.$route.params.id);
  },
};
</script>
